import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { company } from "../mock";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user && user.is_admin) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-ink">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden">
        <div className="pointer-events-none absolute -top-24 -left-16 h-80 w-80 rounded-full bg-gold/15 blur-3xl" />
        <img src={company.logo} alt={company.name} className="h-20 w-auto object-contain bg-white rounded-xl p-2 relative" />
        <div className="relative">
          <h1 className="font-display text-4xl text-white leading-tight">Elite Vending<br /><span className="gold-text">Admin Console</span></h1>
          <p className="mt-4 text-white/60 max-w-sm">Manage booking requests and publish blog articles — all in one place.</p>
        </div>
        <p className="relative text-white/40 text-sm">{company.tagline}</p>
      </div>

      {/* Right login */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
          <img src={company.logo} alt={company.name} className="h-16 w-auto object-contain mx-auto lg:hidden" />
          <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-gold-soft px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-gold-dark">
            <ShieldCheck size={14} /> Admins only
          </div>
          <h2 className="mt-4 font-display text-3xl text-ink">Sign in</h2>
          <p className="mt-2 text-muted-foreground text-sm">
            Use your authorized Google account to access the dashboard.
          </p>

          <button
            onClick={login}
            className="mt-7 w-full h-12 rounded-full bg-ink text-white font-semibold flex items-center justify-center gap-3 hover:bg-gold hover:text-ink transition-colors"
          >
            <LogIn size={18} /> Continue with Google
          </button>

          <p className="mt-5 text-xs text-muted-foreground">
            Access is limited to approved administrators. Other accounts will be declined.
          </p>

          <a href="/" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-gold-dark hover:text-gold">
            <ArrowLeft size={15} /> Back to website
          </a>
        </div>
      </div>
    </div>
  );
}
